module.exports = __webpack_public_path__ + "static/aftercare_hero-bb15c8c2a0966d4e196bc881e40aee1e.jpg";